import { useCallback, useState } from 'react';

function readViewed(storageKey: string): Set<string> {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? new Set(parsed) : new Set();
  } catch {
    return new Set();
  }
}

function writeViewed(storageKey: string, set: Set<string>): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(Array.from(set)));
  } catch {
    // localStorage unavailable / quota — degrade silently to in-memory only
  }
}

export function useViewedItems(storageKey: string) {
  const [viewed, setViewed] = useState<Set<string>>(() =>
    readViewed(storageKey),
  );

  const markViewed = useCallback(
    (id: string) => {
      setViewed(prev => {
        if (prev.has(id)) return prev;
        const next = new Set(prev);
        next.add(id);
        writeViewed(storageKey, next);
        return next;
      });
    },
    [storageKey],
  );

  const isViewed = useCallback((id: string) => viewed.has(id), [viewed]);

  return { isViewed, markViewed };
}
